
import 'picturefill'; 
import 'picturefill/dist/plugins/mutation/pf.mutation.min';
import 'waypoints/lib/noframework.waypoints.min';
import 'lazysizes';
import SmoothScroll from 'smooth-scroll';
import Masonry from 'masonry-layout'

import JournalLoader from './JournalLoader'
import ProjectsLoader from './ProjectsLoader'

class PaulsenNilsen {

	constructor() {

		this.employeeContainer = document.querySelector('.employees__list');
		this.toggleMenuButton = document.querySelector('.site-header__toggle-menu-button')
		this.init();
	}

  
	openMenu() {
		this.toggleMenuButton.setAttribute('aria-expanded', true)
		document.body.classList.add('navigation-is-open')
		document.body.classList.remove('navigation-is-closed')
	}

	closeMenu() {
		this.toggleMenuButton.setAttribute('aria-expanded', false)
		document.body.classList.add('navigation-is-closed')
		document.body.classList.remove('navigation-is-open')
	}


	init() {


		const projectsLoader = new ProjectsLoader();
		projectsLoader.init()

		const journalLoader = new JournalLoader();

		const scrollToTop = new SmoothScroll('#back-to-top-link', {
			updateURL: false,
			speed: 200,
		});

		this.toggleMenuButton.addEventListener('click', e => {

			document.body.classList.contains('navigation-is-open') ? this.closeMenu() : this.openMenu();

		})
		
		window.addEventListener('scroll', e => {
			if ( document.body.classList.contains('navigation-is-open') ) {
				this.closeMenu()
			}
		})

		if ( this.employeeContainer ) {
			const masonry = new Masonry(this.employeeContainer, {
				itemSelector: '.employees__item',
			})
		}
		

	}

}
const site = new PaulsenNilsen();
